// Shared API base + editor auth token for the Welcome Day feature.
//
// In dev the Express API runs on :3001; in prod it's same-origin (Vercel).
// The editor logs in with the shared APP_PASSWORD (via /api/auth) and stores the
// returned token here; write calls (save, image upload) send it as a Bearer
// header. The viewer never sets a token — reads are public.

export const API_BASE = process.env.NODE_ENV === 'development' ? 'http://localhost:3001' : '';

let _token = null;
export function setAuthToken(t) { _token = t || null; }
export function getAuthToken() { return _token; }
export function authHeaders() { return _token ? { Authorization: `Bearer ${_token}` } : {}; }
